import React from 'react';
import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import FileUploader from './FileUploader';
import toast from 'react-hot-toast';
import { setCourse, setStep } from '../../../../../../slices/courseSlice';
import IconBtn from '../../../../../common/IconBtn';
import { MdOutlineNavigateNext } from "react-icons/md";
import { fetchCategories } from './../../../../../../services/operations/JobAPI';
import { createBlog, editBlog } from '../../../../../../services/operations/BlogAPI';
import { setUser } from '../../../../../../slices/profileSlice';

export const RenderCourseInfoForm = () => {

  const dispatch = useDispatch();
  const {token} = useSelector(state => state.auth);
  const {course, step , editCourse} = useSelector(state => state.course)
  const [loading, setLoading] = useState(false);
  const [categories , setCategories] = useState([]);
  const [category,setCategory] = useState("");

  const {

    setValue,
    getValues,
    register,
    handleSubmit,
    reset,
    formState : {errors}

  } = useForm();

  const getCategories = async()=>{
    dispatch(fetchCategories(setCategories));
  }

  useEffect(()=>{
    getCategories();

    
    if(editCourse){
      // console.log("edit: ",editCourse,course);
      setValue("title",course.title);
      setValue("subtitle",course.subtitle);
      setValue("featuredImage",course.featuredImage);
      setValue("category",course.category);
      setCategory(course?.category);
    }
  },[]);
  // console.log("editing: ",getValues());
  // console.log("Blog",course)

  const isFormUpdated = ()=>{
    const currentValues = getValues();
    if(   
      currentValues.title !== course.title ||
      currentValues.subtitle !== course.subtitle ||
      currentValues.featuredImage !== course.featuredImage ||
      currentValues.category !== course.category 
    )
      return true;
    else 
      return false;
  }

  const submitHandler = async(data)=>{
    setLoading(true);
    // console.log("data",data);
    if(editCourse){
      if(isFormUpdated()){
        
        const currentValues = getValues();
        const formData = new FormData();
        
        formData.append("blogId",course._id);

        if(currentValues.title !== course.title)
          formData.append("title",data.title);
        
        if(currentValues.subtitle !== course.subtitle)
          formData.append("subtitle",data.subtitle);

        if(currentValues.featuredImage !== course.featuredImage)
          formData.append("featuredImage",data.featuredImage);

        if(currentValues.category !== course.category)
          formData.append("category",data.category);
        
        //Save the changes in backend 
        // console.log("form: ",Object.fromEntries(formData));
        const result = await editBlog(formData,token);
        if(result){
          dispatch(setCourse(result));
          dispatch(setStep(2));
        }

      }
      else{
        toast.error("No Changes made so far");
      }
      setLoading(false);
      return;
    }

    //Create Course 
    const formData = new FormData();
    formData.append("title",data.title);
    formData.append("subtitle",data.subtitle);
    formData.append("featuredImage",data.featuredImage);
    formData.append("category",data.category);
    // formData.append("status",COURSE_STATUS.DRAFT);

    // console.log("data",data);
    // console.log("formdata",formData);

    const response = await createBlog(formData,token);
    const {result,updatedUser} = response;

    if(result){
      dispatch(setCourse(result));
      dispatch(setUser(updatedUser));
      dispatch(setStep(2));
    }
    setLoading(false);
    // console.log("step: ",step);
  }

  return (
    <form 
      className='my-16 flex flex-col justify-around'
      onSubmit={handleSubmit(submitHandler)}>
      
      <div
        className='flex flex-col gap-6 bg-richblack-800 p-6 max-sm:px-3 rounded border border-richblack-700'>

        {/* Title */}
        <div className='flex flex-col w-full'>
          <label htmlFor='courseTitle'>
            <p>Blog Title <sup>*</sup> </p>
          </label>
          <input
            className='outline-none mt-2 text-richblack-200 w-full p-2 py-2 bg-richblack-700 rounded-lg text-[16px] shadow-[0px_0.8px_0px_0px_#585D69]'
            name='title'
            placeholder='Enter Blog Title'
            type='text'
            {...register("title",{
              required:{
                value:true,
                message:"Blog Title is required"
              }
              })}
          />
        
          {
            errors.title &&
            <span className='mt-1 text-pink-200 text-[12px]'>
              {errors.title.message}
            </span>
          }
        </div>

        {/* Category */}
        <div className='flex flex-col w-full'>
          <label htmlFor="category">
            <p className='text-[16px]'>Blog Category <sup>*</sup> </p>
            <select
                {...register("category",{
                  required:{
                    value:true,
                    message:"Blog category is required"
                  }
                })}
                value={category}
                onChange={(e)=>{setCategory(e.target.value)}}
                id="category"   
                className="outline-none cursor-pointer mt-2 text-richblack-200 w-full p-2 py-2 bg-richblack-700 rounded-lg text-[16px] shadow-[0px_0.8px_0px_0px_#585D69]"
              >
                <option value="" disabled>Choose a Category</option>
                {!loading &&
                    categories.map((category,index)=>{
                        return <option key={index} value={category?._id}>
                                {category?.name}
                            </option>
                    })
                }
              </select>
              {errors.category && (
                  <span className="mt-1 text-pink-200 text-[12px]">
                    {errors.category.message}
                  </span>
              )}
          </label>

        </div>
      
        {/* Description */}
        <div className='flex flex-col w-full'>
          <label htmlFor='courseDescription'>
            <p>Blog Sub Title/Tag Line</p>
          </label>
          <textarea
            className='outline-none mt-2 text-richblack-200 w-full min-h-[150px] p-2 py-2 bg-richblack-700 rounded-lg text-[16px] shadow-[0px_0.8px_0px_0px_#585D69]'
            name='subtitle'
            placeholder='Enter Subtitle'
            {...register("subtitle",{
              // required:{
              //   value:true,
              //   message:"Required"
              // }
              })}
          />
          {
            errors.subtitle &&
            <span className='mt-1 text-pink-200 text-[12px]'>
              {errors.subtitle.message}
            </span>
          }
        </div>

        {/* Thumbanil Upload */}
        <FileUploader
          label={"Featured Image"}
          name={"featuredImage"}
          register={register}
          required={false}
          errors={errors}
          setValue={setValue}
          editData={editCourse ? course?.featuredImage : ""}
        />

      <div className='flex flex-wrap-reverse self-end gap-5'>
        {
          editCourse &&
            <button
            type='button'
              className='bg-richblack-300 text-richblack-900 font-bold p-2 px-3 rounded-md'
              onClick={()=>{
                dispatch(setStep(2))
              }}>
              Continue Without Saving
            </button>
        }
        <IconBtn
          text={!editCourse ? "Next" : "Save Changes"}
          disabled={loading}
        >
          <MdOutlineNavigateNext />
        </IconBtn>
      </div>

      </div>
    </form>
  )
}
